import {useDispatch, useSelector} from "react-redux";
import {setRememberMe} from "../../../redux/slice/authSlice";
import useValueChangeListener from "../../services/state/general/useValueChangeListener";

const AlwaysRememberMe = () => {

    const dispatch = useDispatch();
    const { rememberMe } = useSelector(state => state.local.auth);

    useValueChangeListener(() => {
        console.log("Checking remember me");
        if(!rememberMe) {
            console.log("setting remember me");
            dispatch(setRememberMe({isChecked: true}))
        }
    }, [1], [0]);

    return <></>
}

export default AlwaysRememberMe;
